import { useEffect, useState } from 'react';
import { FiTrash2, FiChevronDown } from 'react-icons/fi';
import { getQueries, updateQuery, deleteQuery } from '../../api';
import { useToast } from '../../components/Toast';
import Loader from '../../components/Loader';

export default function AdminQueries() {
  const [queries, setQueries] = useState(null);
  const [filter, setFilter] = useState('all');
  const [openId, setOpenId] = useState(null);
  const { toast, ToastHost } = useToast();

  const load = () => getQueries().then(setQueries).catch(() => setQueries([]));
  useEffect(() => { load(); }, []);

  const setStatus = async (q, status) => { await updateQuery(q._id, { status }); load(); };
  const remove = async (q) => {
    if (!window.confirm('Delete this enquiry?')) return;
    await deleteQuery(q._id);
    toast('Enquiry deleted');
    load();
  };

  if (!queries) return <Loader />;
  const shown = filter === 'all' ? queries : queries.filter((q) => q.status === filter);

  return (
    <div>
      <div className="acontent__head"><h1>Enquiries <span className="muted" style={{ fontSize: 16 }}>({queries.length})</span></h1></div>

      <div className="toolbar">
        {['all', 'new', 'read', 'closed'].map((s) => (
          <button key={s} className={`chip ${filter === s ? 'active' : ''}`} onClick={() => setFilter(s)}>{s}</button>
        ))}
      </div>

      {shown.length === 0 ? (
        <div className="empty"><div className="empty__icon">📭</div><h3>No enquiries</h3></div>
      ) : (
        <div className="flex" style={{ flexDirection: 'column', gap: 12 }}>
          {shown.map((q) => (
            <div key={q._id} className="acard" style={{ margin: 0 }}>
              <div className="between wrap" style={{ gap: 10, cursor: 'pointer' }} onClick={() => setOpenId(openId === q._id ? null : q._id)}>
                <div>
                  <strong>{q.name || q.data?.name || 'Anonymous'}</strong>
                  <div className="muted" style={{ fontSize: 13 }}>
                    {q.email || q.data?.email || ''} {q.phone ? `· ${q.phone}` : ''}
                  </div>
                </div>
                <div className="flex gap center">
                  <span className="badge">{q.source}{q.refName ? `: ${q.refName}` : ''}</span>
                  <span className={`pill ${q.status}`}>{q.status}</span>
                  <span className="muted" style={{ fontSize: 12 }}>{new Date(q.createdAt).toLocaleDateString()}</span>
                  <FiChevronDown style={{ transform: openId === q._id ? 'rotate(180deg)' : 'none', transition: '.2s' }} />
                </div>
              </div>

              {openId === q._id && (
                <div style={{ marginTop: 14, borderTop: '1px solid var(--border)', paddingTop: 14 }}>
                  {q.message && <p style={{ marginBottom: 12 }}>{q.message}</p>}
                  {q.data && Object.keys(q.data).length > 0 && (
                    <div className="table-wrap" style={{ marginBottom: 14 }}>
                      <table className="atable">
                        <tbody>
                          {Object.entries(q.data).map(([k, v]) => (
                            <tr key={k}><th style={{ width: 180 }}>{k}</th><td>{Array.isArray(v) ? v.join(', ') : String(v)}</td></tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  <div className="flex gap wrap center">
                    <span className="muted" style={{ fontSize: 13 }}>Mark as:</span>
                    {['new', 'read', 'closed'].map((s) => (
                      <button key={s} className={`chip ${q.status === s ? 'active' : ''}`} onClick={() => setStatus(q, s)}>{s}</button>
                    ))}
                    <div style={{ flex: 1 }} />
                    <button className="icon-btn danger" onClick={() => remove(q)}><FiTrash2 /></button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
      <ToastHost />
    </div>
  );
}
